<template>
  <div style="height: 100%;width: 100%;overflow: hidden;position:relative;display: flex;justify-content: center; align-items: center">
    <div style="width: 200px;">
      <div v-if="code.length > 0" @click="copyCode" style="border: black 1px solid;padding: 20px;font-size: 30px;text-align: center;cursor:pointer;">
        <div>{{code}}</div>
      </div>
      <div v-if="remaining >= 0" style="border: black 1px solid;padding: 5px;font-size: 20px;margin-top: 10px;text-align: center">
        <div>有效期：{{remaining}}秒</div>
      </div>
    </div>
  </div>
</template>

<script>
import speakeasy from "speakeasy";
import base32 from "thirty-two";

export default {
  name: "index",
  data() {
    return {
      secret: "",
      code: "",
      remaining: -1,
      interval: null,
    }
  },
  created() {
    const secret = this.$route.params.secret;
    if (secret.length > 0 && this.validSecret(secret)) {
      this.secret = secret;
      this.generate2FACode(secret);
      this.interval = setInterval(this.refresh2FACode, 1000)
    }
   },
  methods: {
    copyCode() {
      this.$copyText(this.code)
      this.$message.success('验证码复制成功', 1);
    },
    validSecret(secret) {
      const cleanedSecret = secret.replace(/\s+/g, '').toUpperCase();
      return /^[A-Z2-7]+=*$/.test(cleanedSecret);
    },
    refresh2FACode() {
      let result = this.generate2FACode(this.secret);
      this.code = result.code
      this.remaining = result.remaining
    },
    generate2FACode(secret) {
      try {
        // 解码Base32秘钥
        const secretBuffer = base32.decode(secret);
        // 生成TOTP验证码
        let now = Date.now()
        const token = speakeasy.totp({
          secret: secretBuffer,
          encoding: 'base32',
          time: now / 1000
        });
        // 计算剩余有效时间（秒）
        const currentTimeSeconds = Math.floor(now / 1000);
        const remaining = 30 - (currentTimeSeconds % 30);
        return {
          code: token,
          remaining
        };
      } catch (error) {
        console.error('生成2FA验证码失败:', error.message);
        throw new Error('处理2FA秘钥时出错: ' + error.message);
      }
    }
  }
}
</script>

<style scoped>
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-thumb {
  background-color: #ddd;
  border-radius: 3px;
}
</style>
